export enum EChartType {
  None = 0,
  LineChart = 1,
  BarChart = 2,
  PieChart = 3,
  DoughnutChart = 4,
}
